import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Preview = ({ meta: { name, percent, previewUrl } }) => (_jsxs("div", { className: "dzu-previewContainer", style: { gap: '1rem' }, children: [_jsx("figure", { children: previewUrl && (_jsx("picture", { children: _jsx("img", { className: "dzu-previewImage", src: previewUrl, alt: name, title: name, style: {
                        width: 180,
                        height: 130,
                        minHeight: 0,
                        minWidth: 0,
                        maxHeight: 'unset',
                        maxWidth: 'unset',
                        objectFit: 'cover',
                        display: 'block',
                    } }) })) }), _jsxs("div", { style: { flex: '1 1 auto' }, children: [_jsx("div", { className: "dzu-previewStatusContainer", children: _jsx("progress", { max: "100", value: Math.round(percent), style: { flex: '1 1 auto' } }) }), _jsx("span", { className: "dzu-previewFileName", children: name })] })] }));
export default Preview;
